module.exports = {
      id: "android-usage",
      viewBox: "0 0 114 35",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#android",
      toString: function () {
        return this.url;
      }
    }